.loadingWrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.loadingSpinner {
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  border: 3px solid #d9deea;
  border-top-color: var(--color-text);
  border-radius: 999px;
  animation: access-gate-spin 0.8s linear infinite;
  margin-bottom: 16px;
}

@keyframes access-gate-spin {
  to {
    transform: rotate(360deg);
  }
}
